// extracted by mini-css-extract-plugin
export var isPrintedCell = "_yo-1";
export var printerIcon = "_yo-0";